module.exports = require("live/components/ui/ExtensionPoint");